// extracted by css-extract-rspack-plugin
export default {"center":"center--cGxh6QFYecVEgJVs"};